<template>
    <label class="pp-switch" 
        :class="{'is-active': isActive, 'is-disabled': currentDisabled}" 
        :style="{ background: (color && isActive) ? color : null }"
        @click="click">
    </label>
</template>

<script>
/**
 * 开关
 * @desc 未指定inactive-value和active-value时, v-model返回true/false
 * @param {[boolean, number, string]} value v-model绑定值
 * @param {[string, number]} activeValue 开启值
 * @param {[string, number]} inactiveValue 关闭值
 * @param {string} color 开启颜色
 * @param {boolean} disabled 禁用状态
 */
export default {
    name: 'pp-switch',
    inject: {
        Form: {
            default: ''
        },
        FormItem: {
            default: ''
        },
    },
    props: {
        value: {
            type: [Boolean, Number, String],
            default: false,
        },
        activeValue: [Number, String],
        inactiveValue: [Number, String],
        color: String,
        disabled: Boolean,
    },
    computed: {
        isActive: function() {
            if(this.activeValue != null) {
                return this.value === this.activeValue;
            }
            else {
                return !!this.value;
            }
        },
        currentDisabled: function() {
            return this.Form.disabled || this.disabled;
        },
    },
    methods: {
        click: function() {
            if(this.currentDisabled) return;

            let value = null;

            if(this.isActive) {
                value = this.activeValue == null ? !this.value : this.inactiveValue
            }
            else {
                value = this.inactiveValue == null ? !this.value : this.activeValue
            }
            this.$emit('input', value)
            this.$emit('change', value)
        },
    },

}
</script>
